import React from "react";
// import {ReactComponent as EventInfoIcon} from "../../assets/img/Sidebar/event-info-icon.svg"
// import {ReactComponent as AnalyticsIcon} from "../../assets/img/Sidebar/analytics-icon.svg"
import {
	OverviewIcon,
	EventInfoIcon,
	AnalyticsIcon,
	ParticipantsIcon,
	ContactIcon,
	GamificationIcon,
	PostEventIcon,
	//SettlementsIcon,
	AdvancedIcon,
	TicketsNdCouponsIcon,
	FormsIcon,
	EventNdOrganiserIcon,
	DiscountIcon,
	SponsorsIcon,
	AttendeesIcon,
	WaitlistIcon,
	LeadsIcon,
	ApprovalIcon,
	DETCode,
	EmailIcon,
	SmsIcon,
	WhatsAppIcon,
	ReferralIcon,
	QuizIcon,
	WidgetIcon,
	AdvancedTemplateIcon,
	AppsIcon,
	SponsorAppIcon,
	WorkshopIcon,
	FloorPlansIcon,
	ExhibitorIcon,
	PartnerIcon,
	ModuleIcon,
	FeedbackIcon,
	CheckinAppIcon,
	GalleryPageIcon,
	AIPhotoBoothIcon,
	AdvancedEventTemplateIcon,
	BrandingAndCustomizationIcon,
	Integrations,
	AttendeeUploads,
	DeveloperIcon,
	ApiIcons,
	WidgetIcons,
	WebhookIcon,
	Payment,
	PaymentMethods,
	OrganizerIcon,
	TaxNCharges,
	CreditsIcon,
	ExhibitorPortalIcon,
	SetupAndBrandingIcon,
	ExhibitorsIcon,
	TaskManagementIcon,
	TaskResponseIcon,
} from "../../assets/img/Sidebar/index";
import CountBadge from "../../revampComponents/Atom/Badge/CountBadge";
import { getCurrentEventId } from "../../Utils/helpers";
import { Icon } from '@iconify/react';
import { dashboardColors, theme } from "../../themes/Theme";

const eventId = getCurrentEventId();

/* 	{
		name: "Overview", -> This is name of the sidebar
		to: `/`, -> This is which route you want it to go when clicked on it
		icon: <OverviewIcon />, -> The SVG icon you want to display next to the sidebar item
		userType: 4 -> what type of user should it be viewable to (read below to see what this number indicates)
	},
*/

/* 	These are what userType number indicates:
	If userType is 1 only Super Admin will be able to see it (reachus@konfhub.com)
	If userType is 2 Super Admin & konfhub team (users with codeops.tech email) will be able to see it,
	If userType is 3 Super Admin, konfhub team & normal user will be able to see it,
	If userType is 4 Super Admin, everyone will be able to see it

	Note: this is how it is done in the FE but actually userType 4 means organizer
*/
const _nav = [
	{
		name: "Overview",
		to: `/`,
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="hugeicons:file-search"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4
	},
	{
		name: "Analytics",
		to: `/stats/analytics`,
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="hugeicons:chart-bar-line"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4
	},
	{
		name: "Event Info",
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="hugeicons:calendar-02"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4,
		subMenus: [
			{
				name: "Event Details",
				to: `/eventInfo/eventdetails/basic`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="lucide:text"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>

				),
			},
			{
				name: "Tickets",
				to: `/eventInfo/tickets/tickets`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="mynaui:ticket"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Forms",
				to: `/eventInfo/forms/forms`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="lets-icons:form-light"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Coupons",
				to: `/eventInfo/coupons`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="iconamoon:discount-light"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Organizer Details",
				to: `/eventInfo/organiserDetails`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="hugeicons:identity-card"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Speakers",
				to: `/eventInfo/speakers/details`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="si:mic-line"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Agenda",
				to: `/eventInfo/agenda/sessions`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="iconamoon:calendar-add-light"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Sponsors",
				to: `/eventInfo/sponsors/details`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="heroicons-outline:user-group"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Workshops",
				to: `/eventInfo/workshop`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="hugeicons:teaching"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			// {
			// 	name: "Floor Plans",
			// 	to: `/eventInfo/floor-plans/details`,
			// 	icon: <FloorPlansIcon />
			// },
			{
				name: "Exhibitors",
				to: `/eventInfo/exhibitor/details`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="iconoir:group"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Partners",
				to: `/eventInfo/partners/details`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="lucide:handshake"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			}
		]
	},
	{
		name: "Modules",
		to: `/modules/module`,
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="streamline-ultimate:module-three"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4,
	},
	{
		name: "Participants",
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="grommet-icons:group"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		countBadge: true,
		userType: 4,
		subMenus: [
			{
				name: "Attendees",
				to: `/attendees`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="hugeicons:user-list"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				countBadge: true
			},
			{
				name: "Team Registrations",
				to: `/team-registrations`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="streamline-ultimate:team-meeting"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				countBadge: true
			},
			{
				name: "Waitlist",
				to: `/waitlist`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="streamline-sharp:time-lapse"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				countBadge: true
			},
			{
				name: "Reg. Attempts",
				to: `/leads`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="mynaui:search-user"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				countBadge: true
			},
			{
				name: "Approval Requests",
				to: `/approval`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="solar:user-check-linear"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				countBadge: true
			},
			{
				name: "Attendee Uploads",
				to: `/attendee-uploads`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="fluent-mdl2:people-add"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				countBadge: false
			},
			{
				name: "DET Codes",
				to: `/det-codes-upload`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="mage:file-upload"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				countBadge: false
			}
		]
	},
	{
		name: "Contact Attendees",
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="mynaui:chat-plus"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4,
		subMenus: [
			{
				name: "Email",
				to: `/email`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="mage:email"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			/*
			{
				name: "SMS",
				to: `/sms`,
				icon: <SmsIcon />
			},
			*/
			{
				name: "WhatsApp",
				to: `/whatsapp`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="iconoir:whatsapp"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			}
		]
	},
	{
		name: "Team",
		to: `/team`,
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="hugeicons:add-team"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4
	},
	{
		name: "Gamification",
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="hugeicons:puzzle"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4,
		subMenus: [
			{
				name: "Referral Contest",
				to: `/ReferralContest`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="hugeicons:share-02"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "Quizzes",
				to: `/Quiz`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="hugeicons:quiz-02"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			}
		]
	},
	{
		name: "Payments & Taxes",
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="lets-icons:table-settings-light"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4,
		subMenus: [
			{
				name: "Bank Details",
				to: `/payment/bankDetails`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="hugeicons:bank"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "Tax & Charges",
				to: `/charges/tax`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="solar:calculator-linear"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "Payment Methods",
				to: `/payment/methods`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="mynaui:credit-card-plus"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			}
		]
	},
	{
		name: "Post Event",
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="mynaui:calendar-check"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4,
		subMenus: [{
			name: "Feedbacks", to: `/feedback`, icon: (
				<div className="sidebar-item">
					<Icon
						icon="tabler:thumb-up"
						height="22px"
						width="22px"
						style={{ color: dashboardColors.light.iconColor }}
					/>
				</div>
			),
		}]
	},
	{
		name: "Settlements",
		to: `/settlements`,
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="iconoir:lot-of-cash"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 2
	},
	{
		name: "Advanced",
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="ci:settings"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4,
		subMenus: [
			{
				name: "Email Templates",
				to: `/advanced/advancedMail`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="hugeicons:filter-mail-square"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "Event Page Templates",
				to: `/advanced/advancedEventPage`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="mynaui:layout"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "White Label",
				to: `/advanced/brandingAndCustomization/branding`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="tabler:brush"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			}
			// {
			//     name: "Widgets",
			//     to: `/advanced/widget`,
			//     icon: <WidgetIcon />,
			// },
		]
	},
	{
		name: "Exhibitor Portal",
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="tabler:building-store"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4,
		subMenus: [
			{
				name: "Setup & Branding",
				to: `/exhibitor-portal/setup-and-branding`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="mage:filter"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "Exhibitors",
				to: `/exhibitor-portal/exhibitors`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="iconoir:group"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "Task Management",
				to: `/exhibitor-portal/task-management`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="hugeicons:task-add-02"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "Task Responses",
				to: `/exhibitor-portal/task-responses`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="proicons:task-list"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "Asset Library",
				to: `/exhibitor-portal/asset-library`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="proicons:library"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
		]
	},
	{
		name: "Apps & Utilities",
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="grommet-icons:apps-rounded"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4,
		subMenus: [
			{
				name: "Sponsor App",
				to: `/SponsorApp`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="ph:handshake"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "Check-in App",
				to: `/CheckinApp/details`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="streamline-ultimate:messages-people-user-check"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
				badge: ""
			},
			{
				name: "Attendee App",
				to: `/attendee-app/settings/branding`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="heroicons:user-group"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "AI Gallery",
				to: `/app/gallery/details`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="solar:gallery-broken"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			// {
			// 	name: "AI Photo Booth",
			// 	to: `/app/ai-photo-booth/details`,
			// 	icon: <AIPhotoBoothIcon />
			// }
		]
	},
	{
		name: "Developers",
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="hugeicons:ai-computer"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4,
		subMenus: [
			{
				name: "API Integrations",
				to: `/developers/integrations`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="bitcoin-icons:node-0-connections-outline"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Reg. Buttons",
				to: `/developers/widgets`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="proicons:button"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Widgets",
				to: `/developers/embed`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="solar:code-square-linear"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
			{
				name: "Webhook",
				to: `/developers/webhook`,
				icon: (
					<div className="sidebar-item">
						<Icon
							icon="ph:webhooks-logo-light"
							height="22px"
							width="22px"
							style={{ color: dashboardColors.light.iconColor }}
						/>
					</div>
				),
			},
		]
	},
	{
		name: "Credits",
		to: `/credits/request`,
		icon: (
			<div className="sidebar-item">
				<Icon
					icon="system-uicons:coins"
					height="22px"
					width="22px"
					style={{ color: dashboardColors.light.iconColor }}
				/>
			</div>
		),
		userType: 4
	}
];

export default _nav;